var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendario2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.625 12H1.37503C0.616516 12 0 11.3835 0 10.6249V2.37494C0 1.61642 0.616516 1 1.37503 1H10.625C11.3835 1 12 1.61642 12 2.37494V10.6249C12 11.3835 11.3835 12 10.625 12ZM1.37503 1.75C1.03052 1.75 0.75 2.03043 0.75 2.37494V10.6249C0.75 10.9695 1.03052 11.25 1.37503 11.25H10.625C10.9695 11.25 11.25 10.9695 11.25 10.6249V2.37494C11.25 2.03043 10.9695 1.75 10.625 1.75H1.37503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.625 4.75H0.375C0.167999 4.75 0 4.582 0 4.375C0 4.168 0.167999 4 0.375 4H11.625C11.832 4 12 4.168 12 4.375C12 4.582 11.832 4.75 11.625 4.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.875 3C2.668 3 2.5 2.832 2.5 2.625V0.375C2.5 0.167999 2.668 0 2.875 0C3.082 0 3.25 0.167999 3.25 0.375V2.625C3.25 2.832 3.082 3 2.875 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.125 3C8.918 3 8.75 2.832 8.75 2.625V0.375C8.75 0.167999 8.918 0 9.125 0C9.332 0 9.5 0.167999 9.5 0.375V2.625C9.5 2.832 9.332 3 9.125 3Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendario2);
export default __webpack_public_path__ + "static/media/calendario 2.c33505f493129c3fb980a60492f9eb6d.svg";
export { ForwardRef as ReactComponent };